export default {"src":"/_next/static/media/bankError.ddf37dc4.svg","height":188,"width":300,"blurWidth":0,"blurHeight":0};